const siteRootUrl = "Site";

const getSiteList = `${siteRootUrl}/list`;

const getSiteDataSourceUrl = siteId => `site/${siteId}/datasource/`;

const getAddSiteDateSourceUrl = siteId => `${getSiteDataSourceUrl(siteId)}add`;
const getRemoveSiteDateSourceUrl = siteId => `${getSiteDataSourceUrl(siteId)}remove`;

const getSiteDemandUrl = siteId => `site/${siteId}/demand`;

const getSitePowerUrl = siteId => `site/${siteId}/power`;

export default {
  siteRootUrl,
  getSiteList,
  getAddSiteDateSourceUrl,
  getRemoveSiteDateSourceUrl,
  getSitePowerUrl,
  getSiteDemandUrl
};
